export const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const API_KEY = process.env.REACT_APP_API_URL;
